import React from 'react'
import {
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const AuthorizationImages = ({ classes, images, onRemoveImage }) => {
  if (!images || images.length === 0) {
    return null
  }

  return (
    <div className={classes.imageContainer}>
      <ImageList
        rowHeight={600}
        className={classes.imageList}
        cols={2}
      >
        {images.map((image) => (
          <ImageListItem key={image.id} cols={image.cols || 1}>
            <img src={image.imageUrl} alt={image.title} />
            <ImageListItemBar
              title={image.title}
              actionIcon={
                <IconButton
                  color="action"
                  onClick={() => onRemoveImage(image.id)}
                >
                  <CloseIcon />
                </IconButton>
              }
            />
          </ImageListItem>
        ))}
      </ImageList>
    </div>
  )
}

export default AuthorizationImages
